export enum AppNewsRoutesEnum {
    APP_NEWS_LIST = 'app-news-list',
    APP_NEWS_DETAIL = 'app-news-detail',
}
